import React from 'react';
import styles from './style.module.scss';
import Image, { ImageProps } from 'next/image';
import Typography from '@/components/shared/typography/typography.component';

import { ITypographyComponentEl } from '@/components/shared/typography/typography.types';

interface CardIconBaseProps extends ImageProps {
    wrapperClassName?: string;
}

export enum ENoItemsCardInfoTextVariant {
    'TITLE' = 'TITLE',
    'SUBTITLE' = 'SUBTITLE',
}

interface CardInfoTextProps extends React.ComponentProps<'p'> {
    text: string;
    variant: ENoItemsCardInfoTextVariant;
    component?: ITypographyComponentEl;
}

type CarSectionBaseProps = React.ComponentProps<'section'>;

const Root: React.FC<CarSectionBaseProps> = ({ children }) => {
    return (
        <div className={styles.rootContainer}>
            <>{children}</>
        </div>
    );
};

const Text: React.FC<CardInfoTextProps> = ({
    text,
    variant,
    component = 'p',
    ...props
}) => {
    const getClassName = (): string => {
        switch (variant) {
            case ENoItemsCardInfoTextVariant.TITLE:
                return styles.title;
            case ENoItemsCardInfoTextVariant.SUBTITLE:
            default:
                return styles.subtitle;
        }
    };
    const className = getClassName();
    return (
        <Typography {...props} className={className} component={component}>
            {text}
        </Typography>
    );
};

const FallbackImage: React.FC<CardIconBaseProps> = ({ src, alt, ...props }) => (
    <div className={props.wrapperClassName || styles.imageWrapper}>
        <Image width={335} height={131} src={src} alt={alt} {...props} />
    </div>
);
export const ProfileFallback = {
    Root: Root,
    Text: Text,
    Image: FallbackImage,
};
